import axios from "axios";
import router from "../router";
import Swal from "sweetalert2";

let isRedirecting = false;

export const axiosInstance = axios.create({});

// axiosInstance.interceptors.request.use(
//   async (config) => {
//     const token = localStorage.getItem("jwtToken");
//     if (
//       token !== null &&
//       token !== undefined &&
//       typeof token === "string" &&
//       token.trim() !== ""
//     ) {
//       config.headers.Authorization = `Bearer ${token}`;
//     } else {
//       if (window.location.pathname.includes("/dashboard")) {
//         // TODO: Show a notification to the user about session expiration before redirecting to login page
//         await Swal.fire({
//           title: "Session Expired",
//           text: "Your session has expired. Please login again.",
//           icon: "error",
//           confirmButtonText: "OK",
//         });

//         void (await router.push("/login"));
//       }
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   },
// );

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("jwtToken");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (res) => res,
  async (error) => {
    const message = error.response.data.message.toLowerCase() || "";

    if (
      message.includes("session") &&
      message.includes("expired") &&
      !isRedirecting
    ) {
      isRedirecting = true;

      localStorage.removeItem("jwtToken");

      await router.push("/login");

      await Swal.fire({
        title: "Session Expired",
        text: "Your session has expired. Please login again.",
        icon: "error",
        confirmButtonText: "OK",
        timer: 3000,
        timerProgressBar: true,
      });

      isRedirecting = false;
    }

    return Promise.reject(error);
  },
);

// axiosInstance.interceptors.response.use(
//   (res) => res,
//   (error) => {
//     const message = error.response.data.message.toLowerCase() || "";
//     const status = error.response.status;
//     const url = error.config.url || "";

//     const isAuthRoute = url.includes("/auth/loginUser");

//     const isSessionExpired =
//       message.includes("session") && message.includes("expired");

//     if (!isAuthRoute && isSessionExpired && !isRedirecting) {
//       isRedirecting = true;

//       localStorage.removeItem("jwtToken");

//       router.push("/login").finally(() => {
//         isRedirecting = false;
//       });
//     }

//     return Promise.reject(error);
//   },
// );

export default axiosInstance;
